import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss'],
})
export class NavContentComponent {}
